module.exports = __webpack_public_path__ + "img/illustrasi_step_project_success.8dd4a446.png";